const locale = require('./printOverview.i18n.json');

/*@ngInject*/
const PrintOverviewController = function ($scope, $controller, $stateParams, $state, currentSubmissionModel, submissionMediator, submissionStateMediator, formViewerConstant, $timeout, watchManagerUtil) {
    angular.extend(this, $controller('submissionFormViewerController', {$scope: $scope}));

    $scope.i18n = locale;
    $scope.printViewModel = {
        formId: _.parseInt($stateParams.formSummaryInstanceId || $stateParams.formId),
        effectiveDate: currentSubmissionModel.getCurrentSubmission().effectiveDate,
        currencyCode: currentSubmissionModel.getCurrentSubmission().currencyCode
    };

    function loadSubmission() {
        let submission = submissionMediator.getCurrentSubmission();
        $scope.printViewModel.customerName = submission.insured.name;
        $scope.printViewModel.status = submission.status;
        $scope.printViewModel.statusLabel = $scope.i18n.status[submission.status];
        $scope.printViewModel.reason = submission.statusReason;
        $scope.printViewModel.detail = submission.statusDetail;
    }

    $scope.$on(formViewerConstant.event.FORM_DATA_READY, function (event, formData) {
        $scope.printViewModel.formName = _.get(formData, 'formModel.formTemplateDisplayName', null);
    });

    $scope.$on(formViewerConstant.event.FORM_LAZY_RENDERING_END, function (event, formData) {
        $timeout(function () {
            watchManagerUtil.clearWatcherList($scope);
        }, 1000);
    });


    $scope.backToForm = function () {
        let params = {submissionId: $stateParams.submissionId},
            stateUrl = submissionStateMediator.getSubmissionStateUrl($stateParams.submissionId),
            stateName = 'submission.form';

        if (_.isPlainObject(stateUrl)) {
            params = _.get(stateUrl, 'params', params);
            stateName = _.get(stateUrl, 'name', stateName);
        }

        $state.go(stateName, params, { reload: $state.current.name === 'submission.printCollaboration'});
    };

    loadSubmission();
};

angular.module('gw-um-submission')
    .controller('printOverviewController', PrintOverviewController);
